import "./MasterColonySave.scss"
import React,{useState,useEffect,useRef} from 'react'
import { useLocation,useLoaderData,useNavigate, useOutletContext } from 'react-router-dom';

import { GetTags } from "../../../lib/allPurposeFunctions";
import apiRequest from "../../../lib/apiRequest";

import { MapContainer, TileLayer } from "react-leaflet";
import { SaveIcon } from "../../../lib/myIcons";
import DashboardHeader from "../../../components/dashboardheader/DashboardHeader";
import CancelButton from "../../../components/buttons/cancelbutton/CancelButton";
import encryptedapiRequest from "../../../lib/encryptedapiRequest";
import { useMasterData } from "../../../context/MasterDataContext";
import { setPending } from "../../../lib/transferObjectsStore";

function MasterCitySave() {
    const {toggleMenu} = useOutletContext(); // get the toggleMenu function
    const navigate=useNavigate();

    const location=useLocation();
    const mode = location.state?.mode; 
    const cityid=location.state?.cityid; 

    console.log("Mode:", mode);


    const [cityData, setCityData] = useState(null);
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(null);


    // coming from different page
    const isFromPending = location.state?.fromPending === true;
    const pendingData = location.state?.pendingData;
    console.log("pendingData",pendingData);



    let headerTitle=mode===0?"New City":"Edit City";
    if (mode===0 && isFromPending) headerTitle="Approve or Reject City";

    


    const fetchCity = async () => {
    try {
        // setLoading(true);
        const response = await encryptedapiRequest.get(`/masters/cities/${cityid}`);
        // setLoading(false);
        return response.data;
    } catch (error) {
        console.error("Fetching colony failed:", error);
        // setLoading(false);
        throw error;
    }
    };

    const LoadCity= async()=>{
        try {
            setLoading(true);
            const data=await fetchCity();
            console.log("fetched from server ",data[0]);
            
            setCityData(data[0]);
        } catch (error) {
            setError(error)
            console.error("Error fetching city data:", error);      

        }finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        if (mode === 1){
            LoadCity();
        }
    }, [ mode ]);





    
    const [formData, setFormData] = useState({
        cityname: "",
        latitude: "",
        longitude: "",
        remark:"",
    });


    // from different form
    useEffect(() => {
    if (mode === 0 && isFromPending && pendingData) {
        setFormData({
        cityname: pendingData.cityname ?? "",
        latitude: pendingData.latitude ?? "",
        longitude: pendingData.longitude ?? "",
        remark:"",

        });
    }
    }, [mode, isFromPending, pendingData]);

    /// edit
    useEffect(() => {
        if (mode === 1 && cityid ) {
            const loadCity = async () => {
            try {
                const data = await fetchCity();
                const cityData = data[0]; // ✅ FIX
                setFormData({
                cityname: cityData.cityname ?? "",
                latitude: cityData.latitude ?? "",
                longitude: cityData.longitude ?? "",
                // remark:cityData.remark ?? "",
                });
            } catch (err) {
                console.error(err);
            }
            };

            loadCity();
        }
        }, [mode, cityid]);


  console.log("Formdata ",formData)



const handleChange = (e) => {
    const { name,value } = e.target;
    setFormData((prev) => ({
        ...prev,
        [name]:value
    }));
};



// const handleSave = async (e) => {
//     e.preventDefault();
//     e.stopPropagation(); // Prevent the click from propagating to the card  
//     // console.log("dd")
//     let res=''
//     const payload=BuildPayload();
//     // console.log("ready Payload",payload)
//     // if (mode===0){
        
//     //         res = await apiRequest.post("/masters/colonies", payload);
//     //         // console.log("Client saved successfully, ID:", res.data);
//     // } else {
//     //       res = await apiRequest.post(`/masters/colonies/${colonyid}`, payload);   
//     //     //   console.log("response from update",res)
//     // }

//     navigate("/admin/colonies")

//   }

// function BuildPayload(){
//     let payload=new Object();
//         if (mode===0){
//         payload.id=0;
//     }
//     else{
//         payload.id=cityid;        
//     }
//     payload.colonyname=formData.colonyname

//     payload.cityid = formData.cityTags
//         .filter(tag => tag.status !== "delete")
//         .map(tag => tag.id)[0] ?? null;
    



//     // payload.cityid=formData.cityTags?.[0]?.id??null

//     payload.latitude=formData.latitude
//     payload.longitude=formData.longitude

//     // console.log("payload : ",payload)

//     return payload
// }


const buildAdminPayload = ({ formData, action }) => {

    
   
return {
    cityname: formData.cityname,
    action, // "approve" | "reject"
    latitude: formData.latitude || "",
    longitude: formData.longitude || "",
    remark:formData.remark || ""
  };
};



  const handleApprove = async (e) => {
    e.preventDefault();
    console.log("approve")
    const payload = buildAdminPayload({ formData, action: "approve" });
    console.log("Admin payload : ",payload )    
    try {
        
        // api for approval 
            // "cityname": "city 4",
            // "action": "approve",
            // "latitude": "33333.5355",
            // "longitude": "44.3910",
            // "remark": "Verified via Google Maps and admin review"

        
        res=apiRequest.post(`/masters/approve/city`, payload);
        console.log("City saved successfully, ID:", res.data);


        const trfobj={
            id:pendingData?.id,
            type:"city",
            action:"approved"
        }   

        setPending("result",trfobj);

    } catch (error) {
        setError(error)
        console.error("Error approving city data:", error);
        
    }




    // handleSave(e);
    navigate(-1, {
        // state: {
        // result: "approved",
        // Id: pendingData?.id,
        // type:"city"
        // }
    });


}

  const handleReject = async (e) => {
    e.preventDefault();
    console.log("reject")
    const payload = buildAdminPayload({ formData, action: "reject" });
    console.log("Admin payload : ",payload )


    try {
        // api for approval 
            // "cityname": "city 4",
            // "action": "reject",
            // "latitude": "33333.5355",
            // "longitude": "44.3910",
            // "remark": "Verified via Google Maps and admin review"
        
        res=apiRequest.post(`/masters/approve/city`, payload);
        console.log("City rejected successfully, ID:", res.data);
        const trfobj={
            id:pendingData?.id,
            type:"city",
            action:"rejected"
        }   
        setPending("result",trfobj);   
    } catch (error) {
        console.error("Error rejecting city data:", error);        
    }

    // handleSave(e);
    navigate(-1, {
        // state: {
        //     result: "rejected",
        //     Id: pendingData?.id,
        //     type:"city"
        // }
    });


  }



  const handleCheck = async (e) => {
    e.preventDefault();

    console.log("formDate: ",formData);

  }


    
// // ✅ Wait until all necessary data is available before rendering

    
    return (
            <>
            <div className="masterColonyPage">
                <div className="PageHeader">
                    <DashboardHeader title={headerTitle} toggleMenu={toggleMenu} variant="admin"></DashboardHeader>
                </div>
                <div className="wrapper">
                    <div className="row">
                        <label>
                            City Name
                        </label>
                        <div className="rowVal">
                            <input 
                                type="text" 
                                name="cityname" 
                                placeholder="City Name" 
                                value={formData.cityname}
                                onChange={handleChange}
                                            
                            />                        
                        </div>
                    </div>


                    <div className="row">
                        <label>
                            Latitude
                        </label>
                        <div className="rowVal">
                            <input 
                                type="text" 
                                name="latitude" 
                                placeholder="Latitude" 
                                value={formData.latitude}
                                onChange={handleChange}
                                            
                            />                        
                            
                        </div>
                    </div>
                    <div className="row">
                        <label>
                            Longitude
                        </label>
                        <div className="rowVal">
                            <input 
                                type="text" 
                                name="longitude" 
                                placeholder="Longitude" 
                                value={formData.longitude}
                                onChange={handleChange}
                                            
                            />                        
            
                        </div>
                    </div>

                    {isFromPending && (
                        
                        <div className="row remark">
                            <label>
                                Remark
                            </label>
                            <div className="rowVal">
                                <input 
                                    type="text" 
                                    name="remark" 
                                    placeholder="Enter Remark" 
                                    value={formData.remark}
                                    onChange={handleChange}
                                                
                                />                        
                
                            </div>
                        </div>
                    )}
                    <div className="row map">
                        <label>
                            Map
                        </label>
                        <div className="rowVal">
                            {formData.latitude && formData.longitude ? (
                            <MapContainer
                                center={[Number(formData.latitude), Number(formData.longitude)]}
                                zoom={14}
                                scrollWheelZoom={false}
                                className="map"
                            >
                                <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                {/* Optional: pins */}
                                {formData.id && <Pin item={formData} />}
                            </MapContainer>
                            ) : (
                            <p>Loading map...</p>
                            )}
                        </div>
                    </div>

                    <div className="row">
                        {isFromPending ? (
                            <>
                            <button onClick={handleApprove}>
                                Approve
                            </button>   
                            <button onClick={handleReject}>Reject </button>
                            </>

                        ):(
                            <button onClick={handleSave}>
                                <SaveIcon color="white"></SaveIcon>
                                Save
                            </button>

                        )}          
                        <CancelButton></CancelButton>

                    </div>
                </div>
          </div>
            </>
    )
}

// }
export default MasterCitySave